import { render, staticRenderFns } from "./tfinish.vue?vue&type=template&id=0fd01ba8&scoped=true"
import script from "./tfinish.vue?vue&type=script&lang=js"
export * from "./tfinish.vue?vue&type=script&lang=js"
import style0 from "./tfinish.vue?vue&type=style&index=0&id=0fd01ba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd01ba8",
  null
  
)

export default component.exports